module.exports = __webpack_public_path__ + "Server-Default.Ftp.2cd7ac1de30b35aa02af45bf686d7ae9.hashedasset.svg";